import React, {useState} from 'react';

import classNames from 'classnames';
import {Container} from 'reactstrap';

import Tabs from 'components/Navigation/Tabs';

import ABScopeContent from './ABScopeContent';

import useGetScopes from './useGetScopes';

import styles from './styles.module.scss';

function ABStandards() {
  const [activeTab, setActiveTab] = useState('main-scope');
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const {data, meta, isLoading} = useGetScopes();
  const {main, sub4, sub5} = data;
  const subScopes = sub5.concat(sub4);
  const {total_rows} = meta || {};

  const tabs = [
    {
      key: 'main-scope',
      tabName: 'Main Scope',
      children: (
        <Container className="p-0" tag="section">
          <h4 className={classNames(styles['section__title--small'], 'mb-4')}>
            Main Scope
          </h4>
          <ABScopeContent scopes={main} isLoading={isLoading} />
        </Container>
      ),
    },
    {
      key: 'sub-scope',
      tabName: 'Sub Scope',
      children: (
        <Container className="p-0" tag="section">
          <h4 className={classNames(styles['section__title--small'], 'mb-4')}>
            Sub Scope
          </h4>
          <ABScopeContent scopes={subScopes} isLoading={isLoading} />
        </Container>
      ),
    },
  ];

  return (
    <section>
      <h3 className={classNames(styles['section__title'], 'mb-4')}>
        IAF Standards {`(${total_rows || 0})`}
      </h3>
      <Tabs
        active={activeTab}
        toggle={toggleTab}
        tabs={tabs}
        navClassname="mb-4"
        tabClassname="mb-4"
      />
    </section>
  );
}

export default ABStandards;
